import {


    typeExport

} from '../../../../redux/store/type';

import {Alert} from "react-native";
import moment from "moment-jalaali";


const reducerSplashSatiaScreen = (state = {
    RestaurantBasketCheck: false,
    FoodItem: null,
    CartList: [],
    StoreId: 0,
    StoreName: '',
    PriceAll: 0,
    DiscountAll: 0,
    error: false,
    user: null,
    token: null,
    isLoading: false,
    NoInternetDialog: false,
    results: null,

    results_City: null,
    showDialohCity: false,
    Rtl: false,
    Lang: 'en',
    NotifUser: 0,
    token_fb: null,
    Background: null,
    Connection: true,
    Location: null,

    TypeLogin: 1,

    idCity: 0,
    item_count: 10,

    unit: "ریال",
    unitValue: 1,
    successLogin: false,

}, action) => {

    let data = null;
    const newState = {...state,};

    switch (action.type) {
        case typeExport.SPLASH_SATIA_SERVICE_REFRESH:
            return {
                ...state,
                NoInternetDialog: false,
                showDialohCity: false,
                results: null,

                error: action.error,
                isLoading: action.isLoading,
            };

        case typeExport.SPLASH_SATIA_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                showDialohCity: false,
                //results: null,

                error: action.error,
                isLoading: action.isLoading,
            };
        case typeExport.SPLASH_SATIA_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: true,
                showDialohCity: false,
                //   results: null,

                error: action.error,
                isLoading: action.isLoading,
                resultsSatia: action.resultsSatia,

            };
        case typeExport.SPLASH_SATIA_SERVICE_SUCCESS:
            return {
                ...state,
                unit: action.results && action.results.info ? action.results.info.unit : null,
                unitValue: action.results && action.results.info ? action.results.info.unitValue : null,
                results: action.results,
                NoInternetDialog: false,
                showDialohCity: false,
                isLoading: action.isLoading,
                /*     token: action.token,
                     user: action.user,*/
            };

        case typeExport.SPLASH_SATIA_SERVICE_PENDING_Satia:
            return {
                ...state,
                NoInternetDialogSatia: false,
                resultsSatia: null,

                error: action.error,
                isLoadingSatia: action.isLoadingSatia,
            };
        case typeExport.SPLASH_SATIA_SERVICE_ERROR_Satia:
            return {
                ...state,
                NoInternetDialogSatia: true,
                showDialohCitySatia: false,
                // resultsSatia: null,

                error: action.error,
                isLoadingSatia: action.isLoadingSatia,
            };
        case typeExport.SPLASH_SATIA_SERVICE_SUCCESS_Satia:
            return {
                ...state,
                resultsSatia: action.resultsSatia,
                NoInternetDialogSatia: false,

                isLoadingSatia: action.isLoadingSatia,

            };

        case typeExport.SPLASH_SATIA_SERVICE_PENDING_CITY:
            return {
                ...state,
                NoInternetDialogCity: false,
                showDialohCity: false,
                resultsCity: null,

                error: action.error,
                isLoadingCity: action.isLoadingCity,
            };
        case typeExport.SPLASH_SATIA_SERVICE_ERROR_CITY:
            return {
                ...state,
                NoInternetDialog: true,
                showDialohCity: false,
                resultsCity: null,

                error: action.error,
                isLoadingCity: action.isLoadingCity,
            };
        case typeExport.SERVICE_SUCCESS_GET_CITY_DATA:
            return {
                ...state,
                NoInternetDialog: false,
                results_City: action.results_City,
                showDialohCity: true,
                isLoading: action.isLoading,
            };
        case typeExport.SERVICE_TOKEN:
            return {
                ...state,
                token: action.token,
            };
        case typeExport.SERVICE_USER:
            return {
                ...state,
                user: action.user,
            };
        case typeExport.SERVICE_CITY:
            return {
                ...state,
                idCity: action.idCity,
            };

        case typeExport.SERVICE_wifiIsEnabled :
            //  console.log("requestLogin=>SERVICE_wifiIsEnabled",action)
            return {
                ...state,
                wifiIsEnabled: action.wifiIsEnabled,

            };

        case typeExport.SERVICE_wifiConnectionStatus:
            return {
                ...state,
                wifiConnectionStatus: action.wifiConnectionStatus,

            };
        case typeExport.SERVICE_ConnectionInternetHotspot:
            return {
                ...state,
                ConnectionInternetHotspot: action.ConnectionInternetHotspot,

            };
        case typeExport.SERVICE_ConnectionType:
            return {
                ...state,
                ConnectionType: action.ConnectionType,

            };

        case typeExport.SERVICE_Account:
            return {
                ...state,
                Account: action.Account,
                indexAccount: action.indexAccount,

            };

        case typeExport.SERVICE_TokenFirebase:
            return {
                ...state,
                token_fb: action.data,
            };
        case typeExport.SERVICE_UserPassWifi:
            return {
                ...state,
                userWifi: action.data ? action.data.userWifi : null,
                passWifi: action.data ? action.data.passWifi : null,
                CodeWifi: action.data ? action.data.CodeWifi : null,

                selectAccount: action.data ? action.data.selectAccount : null,
            };
        case typeExport.SERVICE_NameDynamic:
            return {
                ...state,
                [action.name]: action.data,
            };
        case typeExport.SERVICE_WALLET:
            return {
                ...state,
                wallet: action.wallet,
                typeWallet: action.typeWallet,
            };
        /*
        *   type: typeExport.SERVICE_TIME_SPAN,
beginDate: beginDate,
endDate: data,
month: month,*/
        case typeExport.SERVICE_TIME_SPAN:
            let endDate = null;
            let beginDate = null;
            if (action.month) {
                endDate = moment().format('jYYYY/jM/jD');
                let m = moment(endDate, 'jYYYY/jM/jD');
                beginDate = m.subtract(action.month, 'month').locale('fa').format('jYYYY/jM/jD');
            }

            return {
                ...state,
                beginDate: beginDate ? beginDate : (action.beginDate ? action.beginDate : null),
                endDate: endDate ? endDate : (action.endDate ? action.endDate : null),
                indexSelectMonthType: action.indexSelectMonthType || action.indexSelectMonthType == 0 ? action.indexSelectMonthType : null,
            };
        default:
            return state;
    }
}

export default reducerSplashSatiaScreen;
